import { createTheme } from "@mui/material"

export const theme = createTheme({
    palette: {
        primary: {
            main: "#00947C",
            light: "#00836b"
        }
    }
})